import React from 'react'
import { BankPartial } from './BankPartial'
import { InlineDisplayContent, TextInput } from '@ztechapps/webui.input'
import { BusyButton } from '@ztechapps/webui.button'

export const GenerateBankInfo = ({ onClick, email, setEmail, disabled }) => {
  return (
    <React.Fragment>
      <div>
        <p>
          Bank transfers, also known as ACH payments, can take up to five business days. To pay via ACH, click the
          button below to view the bank information where to transfer the payment.
        </p>
      </div>
      <BankPartial />
      <InlineDisplayContent label="Email" help="Set the email address where we send the bank information.">
        <TextInput value={email} onChange={(e) => setEmail(e?.target?.value)} />
      </InlineDisplayContent>

      <BusyButton bsStyle="primary" text="View bank info" onClick={onClick} disabled={disabled} />
    </React.Fragment>
  )
}
